import React, { HTMLProps } from "react";

interface TextAreaProps {
  error: string;
  value: string;
  onChange: any;
  label: string;
  name: string;
}

function TextArea({ label, error, name, value, onChange }: TextAreaProps) {
  return (
    <label className="labelInput">
      {label && <span>{label}</span>}
      <div className={`containerButton ${error ? "error" : ""}`}>
        <textarea name={name} value={value} onChange={onChange}></textarea>
      </div>
    </label>
  );
}

export { TextArea };
